import React from 'react';
import { useLocation } from 'react-router';

import styled from 'styled-components';

import { Color } from '@assets/constants';
import { icons } from '@assets/icons';
import {
  cartButtonSlideInAnimation,
  cartButtonSlideOutAnimation,
  pressAnimation
} from '@utils/animations';

interface Props {
  isInBounds?: boolean;
  itemsQuantity: number;
  onOpenCart: () => void;
  disabled: boolean;
}

export const CartButton = ({
  onOpenCart,
  itemsQuantity,
  isInBounds = false,
  disabled
}: Props) => {
  const location = useLocation();
  const currentPath = location.pathname;

  return (
    <FixedCartWrapper
      isInBounds={isInBounds}
      isStatic={currentPath === '/checkout'}
      disabled={disabled}
    >
      <CartContainer onClick={() => !disabled && onOpenCart()}>
        <icons.FaShoppingBag color={Color.GRAY} size={25} />
        <CartItemTick>{itemsQuantity}</CartItemTick>
      </CartContainer>
    </FixedCartWrapper>
  );
};

const CartContainer = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0.75rem;
  border-radius: 50%;
  background-color: ${Color.WHITE};
  width: 3.5rem;
  height: 3.5rem;

  ${pressAnimation}
`;

const CartItemTick = styled.div`
  background-color: ${Color.ACCENT};
  position: absolute;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 0.75rem;
  color: white;
  top: 0;
  right: 0;
  width: 1rem;
  height: 1rem;
  border-radius: 50%;
`;

const FixedCartWrapper = styled.div<{
  isInBounds: boolean;
  isStatic: boolean;
  disabled: boolean;
}>`
  cursor: pointer;
  z-index: 800;
  filter: drop-shadow(0px 2px 10px rgba(0, 0, 0, 0.15));

  ${({ isInBounds, isStatic }) => {
    if (isStatic) {
      return ``;
    }

    return !isInBounds
      ? `
        position: fixed;
        ${cartButtonSlideOutAnimation}
        
        @media (max-width: 1024px) {
          top: 1.5rem;
          right: 1.5rem;
        }
      `
      : `
        ${cartButtonSlideInAnimation}
    `;
  }}

  ${({ disabled }) =>
    disabled &&
    `
      filter: grayscale(1) opacity(0.5) brightness(0.8);
      cursor: not-allowed;
  `}
`;
